import { useState, useReducer, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { optionSelector } from "../../config/apiSPA";

function reducer(state, action) {
  switch (action.type) {
    case "activity_id": {
      return { ...state, activity_id: action.value };
    }
    case "instructor_id": {
      return { ...state, instructor_id: action.value };
    }
    case "date": {
      return { ...state, date: action.value };
    }
    case "remark": {
      return { ...state, remark: action.value };
    }
    case "RESET": {
      return initialValue;
    }
    default:
      return state;
  }
}
const initialValue = {
  activity_id: "",
  instructor_id: "",
  date: "",
  remark: "",
};
function OtherActivityNewForm({ onUpdate = () => {} }) {
  const [eventData, eventDataDispatch] = useReducer(reducer, initialValue);
  const [spinner, setSpinner] = useState(false);
  const [listActivity, setListActivity] = useState([]);
  const [listInstructor, setListInstructor] = useState([]);

  const navigate = useNavigate();

  function eventSubmit() {}
  useEffect(() => {
    onUpdate(eventData);
  }, [eventData]);
  useEffect(() => {
    optionSelector(`/activity-other-list`).then((res) => setListActivity(res));
    optionSelector(`/instructor`).then((res) => setListInstructor(res));
  }, []);

  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-12">
            <div className="row">
              <div className="col-xl-12">
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="title">
                    Activity<span className="text-danger">*</span>
                  </label>
                  <Select
                    id="title"
                    options={listActivity}
                    onChange={(e) => eventDataDispatch({ type: "activity_id", value: e.value })}
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="location">
                    Instructor<span className="text-danger">*</span>
                  </label>
                  <Select
                    id="location"
                    options={listInstructor}
                    onChange={(e) => eventDataDispatch({ type: "instructor_id", value: e.value })}
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="startDate">
                    Date<span className="text-danger">*</span>
                  </label>
                  <input type="date" onChange={(e) => eventDataDispatch({ type: "date", value: e.target.value })} className="form-control" id="startDate" />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label text-theme" htmlFor="remark">
                    Remark
                  </label>
                  <textarea onChange={(e) => eventDataDispatch({ type: "remark", value: e.target.value })} className="form-control" id="remark"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OtherActivityNewForm;
